
import { defineComponent, ref } from 'vue';
import route from '@/router';

import cookie from '@/utils/cookie';

export default defineComponent({
	setup() {
		const loggedIn = ref(cookie.get('token') ? true : false);

		const logOut = () => {
			cookie.delete('token');

			loggedIn.value = false;

			route.push('/home');
			window.location.reload();
		};

		return {
			loggedIn,
			logOut,
		};
	},
});
